module.exports = __webpack_public_path__ + "img/3.5c46ae9a.jpg";